"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var styled_components_1 = __importDefault(require("styled-components"));
// Actions
var BotActions_1 = require("@src/actions/BotActions");
// Constants
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var api_1 = require("@src/api");
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var InfoIconV4_1 = __importDefault(require("relements/build/esm/ui/icons/InfoIconV4"));
var utils_1 = require("@src/utils");
var TabContainer_1 = __importDefault(require("../../components/TabContainer"));
var InputBlocks_1 = __importDefault(require("./InputBlocks"));
var constants_1 = require("./constants");
var maps_1 = require("./maps");
require("./GeneralSettings.scss");
var DefaultInfo = styled_components_1["default"](box_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  padding: 14px;\n  width: 482px;\n  margin: -16px 0 16px;\n  align-items: center;\n  border-radius: 4px;\n  gap: 10px;\n  box-sizing: border-box;\n  span {\n    color: ", ";\n    font-family: Proxima Nova;\n  }\n"], ["\n  background-color: ", ";\n  border: 1px solid ", ";\n  padding: 14px;\n  width: 482px;\n  margin: -16px 0 16px;\n  align-items: center;\n  border-radius: 4px;\n  gap: 10px;\n  box-sizing: border-box;\n  span {\n    color: ", ";\n    font-family: Proxima Nova;\n  }\n"])), function (props) { return props.theme.colors.yellow.pastel; }, function (props) { return props.theme.colors.yellow.soft; }, function (props) { return props.theme.colors.yellow.dark; });
// Initial State
var initialState = {
    businessData: {},
    generalSettingsData: {},
    businessDataEdited: false,
    isLoaderActive: true,
    errorList: [],
};
// Reducer
var reducer = function (state, action) {
    var _a;
    switch (action.type) {
        case constants_1.REDUCER_ACTIONS.SET_BUSINESS_DATA:
            return __assign(__assign({}, state), { businessData: action.data.businessData, generalSettingsData: action.data.generalSettingsData, businessDataEdited: false });
        case constants_1.REDUCER_ACTIONS.SET_GENERAL_SETTINGS_DATA:
            return __assign(__assign({}, state), { generalSettingsData: __assign(__assign({}, state.generalSettingsData), (_a = {}, _a[action.data.key] = action.data.value, _a)), businessDataEdited: true });
        case constants_1.REDUCER_ACTIONS.SET_BUSINESS_DATA_EDITED:
            return __assign(__assign({}, state), { businessDataEdited: action.data.businessDataEdited });
        case constants_1.REDUCER_ACTIONS.SET_LOADER_ACTIVE:
            return __assign(__assign({}, state), { isLoaderActive: action.data.isLoaderActive });
        case constants_1.REDUCER_ACTIONS.SET_ERROR_LIST:
            return __assign(__assign({}, state), { errorList: action.data.errorList });
        default:
            return state;
    }
};
// Actions
var generalSettingsActions = function (dispatch) { return ({
    /**
     * Gets all general settings' business data
     */
    setBusinessData: function (businessData) {
        var generalSettingsData = __assign({}, businessData.body);
        // Add default language is languages supported is empty
        if (generalSettingsData[constants_1.INPUT_BLOCK_KEYS.LANGUAGES_SUPPORTED].length === 0) {
            generalSettingsData[constants_1.INPUT_BLOCK_KEYS.LANGUAGES_SUPPORTED].push(constants_1.DEFAULTS.LANGUAGE_CODE);
        }
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_BUSINESS_DATA,
            data: { businessData: businessData, generalSettingsData: generalSettingsData },
        });
    },
    /**
     * Sets general settings' request data
     * @param key key of the item which needs to be updated
     * @param value new value which is to be set
     */
    setGeneralSettingsData: function (key, value) {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_GENERAL_SETTINGS_DATA,
            data: { key: key, value: value },
        });
    },
    /**
     * Sets business edited flag
     * @param businessDataEdited true/false if data has been edited
     */
    setBusinessDataEdited: function (businessDataEdited) {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_BUSINESS_DATA_EDITED,
            data: { businessDataEdited: businessDataEdited },
        });
    },
    /**
     * Sets loader active/inactive
     * @param isLoaderActive true/false if loader needs to be shown
     */
    setLoaderActive: function (isLoaderActive) {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_LOADER_ACTIVE,
            data: { isLoaderActive: isLoaderActive },
        });
    },
    /**
     * Sets list of errors
     * @param errorList errors present when saving
     */
    setErrorList: function (errorList) {
        dispatch({
            type: constants_1.REDUCER_ACTIONS.SET_ERROR_LIST,
            data: { errorList: errorList },
        });
    },
}); };
var GeneralSettings = function () {
    var _a = react_redux_1.useSelector(maps_1.stateToProps), businessId = _a.businessId, viaName = _a.viaName, isSelfServe = _a.isSelfServe;
    var _b = maps_1.dispatchToProps(react_redux_1.useDispatch()), setViaName = _b.setViaName, setPipelineVersion = _b.setPipelineVersion, setActivePartners = _b.setActivePartners;
    var FILE_UPLOAD_DETAILS = constants_1.INPUT_BLOCK_KEYS.FILE_UPLOAD_DETAILS, IS_CUSTOM_BUCKET_ENABLED = constants_1.INPUT_BLOCK_KEYS.IS_CUSTOM_BUCKET_ENABLED, CUSTOM_S3_BUCKET_DETAILS = constants_1.INPUT_BLOCK_KEYS.CUSTOM_S3_BUCKET_DETAILS, S3_BUCKET_NAME = constants_1.INPUT_BLOCK_KEYS.S3_BUCKET_NAME, BUCKET_ARN = constants_1.INPUT_BLOCK_KEYS.BUCKET_ARN, BUCKET_REGION = constants_1.INPUT_BLOCK_KEYS.BUCKET_REGION, EXPIRY = constants_1.INPUT_BLOCK_KEYS.EXPIRY, OBJECT_ACL = constants_1.INPUT_BLOCK_KEYS.OBJECT_ACL;
    var _c = react_1["default"].useReducer(reducer, initialState), state = _c[0], dispatch = _c[1];
    var actions = generalSettingsActions(dispatch);
    var businessData = state.businessData, generalSettingsData = state.generalSettingsData, businessDataEdited = state.businessDataEdited, isLoaderActive = state.isLoaderActive, errorList = state.errorList;
    // Get all business data
    var getBusinessData = function (id) {
        actions.setLoaderActive(true);
        api_1.API.businessV2
            .getBusinessData(id)
            .then(function (_a) {
            var success = _a.success, response = _a.response;
            actions.setLoaderActive(false);
            if (success) {
                actions.setBusinessData(response);
                var activePartners_1 = [];
                response.body.partner_list.forEach(function (partner) {
                    return activePartners_1.push({
                        id: partner,
                        name: response.meta.partner_id_map[partner],
                    });
                });
                setActivePartners(activePartners_1);
                setViaName(response.body.via_name);
                setPipelineVersion(response.body.pipeline_version);
            }
            else {
                BotActions_1.createAlert(response.error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
        })["catch"](function (error) {
            actions.setLoaderActive(false);
            api_1.captureException(error);
        });
    };
    react_1["default"].useEffect(function () {
        getBusinessData(businessId);
    }, []);
    /**
     * Validates the entered data
     * @param key key name of the data in the object
     * @param value value of the said key name of data in the object
     * @param multiSelect if the input is multi-select (for dropdown)
     * @param isMandatory if the input is mandatory
     */
    var validateData = function (key, value, multiSelect, isMandatory) {
        if (typeof value === 'string' || Array.isArray(value)) {
            if ((isMandatory && !value) || (multiSelect && value.length === 0)) {
                if (!errorList.includes(key)) {
                    actions.setErrorList(__spreadArrays(errorList, [key]));
                }
            }
            else {
                actions.setErrorList(errorList.filter(function (item) { return item !== key; }));
            }
        }
        else if (key === FILE_UPLOAD_DETAILS) {
            var customS3Details = value[CUSTOM_S3_BUCKET_DETAILS];
            if (value[IS_CUSTOM_BUCKET_ENABLED] &&
                (!customS3Details[S3_BUCKET_NAME] ||
                    !customS3Details[BUCKET_REGION] ||
                    !customS3Details[BUCKET_ARN] ||
                    !customS3Details[OBJECT_ACL] ||
                    (customS3Details[OBJECT_ACL] === 'private' &&
                        !customS3Details[EXPIRY] &&
                        customS3Details[EXPIRY] !== 0))) {
                if (!errorList.includes(key))
                    actions.setErrorList(__spreadArrays(errorList, [key]));
            }
            else {
                actions.setErrorList(errorList.filter(function (item) { return item !== key; }));
            }
        }
    };
    /**
     * Fires whenever any input is changed
     * @param key key name of the data in the object
     * @param value value of the said key name of data in the object
     * @param multiSelect if the input is multi-select (for dropdown)
     * @param isMandatory if the input is mandatory
     */
    var handleInputChange = function (key, value, multiSelect, isMandatory, meta) {
        actions.setGeneralSettingsData(key, value);
        // Set defaults when active bot is changed
        if (key === constants_1.INPUT_BLOCK_KEYS.ACTIVE_BOTS) {
            actions.setGeneralSettingsData(constants_1.INPUT_BLOCK_KEYS.DEFAULT_BOT, value[0]);
            actions.setGeneralSettingsData(constants_1.INPUT_BLOCK_KEYS.FALLBACK_BOT, value[0]);
        }
        if (key === constants_1.INPUT_BLOCK_KEYS.LIVE_AGENT_CHAT_TOOL) {
            actions.setGeneralSettingsData(constants_1.INPUT_BLOCK_KEYS.TO_ECT, value !== meta[constants_1.INPUT_META_KEYS.ALL_CHAT_TOOLS][0]);
        }
        validateData(key, value, multiSelect, isMandatory);
    };
    var showErrorAlert = function (msg) {
        return BotActions_1.createAlert(msg, undefined, MogamboConstants_1.AlertTypes.NEGATIVE);
    };
    var getErrorForFileUpload = function () {
        var customS3Details = generalSettingsData[FILE_UPLOAD_DETAILS][CUSTOM_S3_BUCKET_DETAILS];
        var errorMessage = 'Storage Type is required.';
        if (!customS3Details[BUCKET_ARN]) {
            errorMessage = 'Bucket ARN is required.';
        }
        else if (!customS3Details[S3_BUCKET_NAME]) {
            errorMessage = 'S3 Bucket Name is required.';
        }
        else if (!customS3Details[BUCKET_REGION]) {
            errorMessage = 'Bucket Region is required.';
        }
        else if (customS3Details[OBJECT_ACL] === 'private' &&
            customS3Details[EXPIRY] !== 0 &&
            !customS3Details[EXPIRY]) {
            errorMessage = 'Expiry Time is required.';
        }
        else if (Number(customS3Details[EXPIRY]) > 604800) {
            errorMessage = 'Expiry Time cannot exceed 604800(7 days).';
        }
        return errorMessage;
    };
    // Update General settings on Save
    var updateGeneralSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var errorMessage, generalSettings_1;
        return __generator(this, function (_a) {
            if (errorList.length > 0) {
                errorMessage = 'Please fill the required fields.';
                if (errorList.includes(FILE_UPLOAD_DETAILS)) {
                    errorMessage = getErrorForFileUpload();
                }
                showErrorAlert(errorMessage);
            }
            else {
                generalSettings_1 = __assign({}, state.generalSettingsData);
                delete generalSettings_1.collectFeedback;
                actions.setLoaderActive(true);
                api_1.API.businessV2
                    .updateBusinessData(businessId, generalSettings_1)
                    .then(function (_a) {
                    var success = _a.success, response = _a.response;
                    actions.setLoaderActive(false);
                    if (success) {
                        BotActions_1.createAlert('General Settings updated successfully!', undefined, MogamboConstants_1.AlertTypes.POSITIVE);
                        var activePartners_2 = [];
                        generalSettings_1.partner_list.forEach(function (partner) {
                            return activePartners_2.push({
                                id: partner,
                                name: state.businessData.meta.partner_id_map[partner],
                            });
                        });
                        setActivePartners(activePartners_2);
                        actions.setGeneralSettingsData(constants_1.INPUT_BLOCK_KEYS.LANGUAGES_SUPPORTED, response.body[constants_1.INPUT_BLOCK_KEYS.LANGUAGES_SUPPORTED]);
                        actions.setBusinessDataEdited(false);
                    }
                    else {
                        BotActions_1.createAlert(response.error, null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    }
                })["catch"](function (error) {
                    actions.setLoaderActive(false);
                    api_1.captureException(error);
                });
            }
            return [2 /*return*/];
        });
    }); };
    // Get all internal inputs
    var getInputs = function (block) {
        var inputsArray = [];
        var inputs = __spreadArrays(block.inputs);
        inputs.forEach(function (elem) {
            var _a;
            var Input = elem.component;
            var inputProps = elem.props(generalSettingsData, __assign(__assign({}, businessData.meta), { isSelfServe: isSelfServe }), handleInputChange);
            if (inputProps.invisible)
                return null;
            inputsArray.push(react_1["default"].createElement(Input, __assign({}, inputProps, { label: elem.label, disabled: typeof inputProps.disabled === 'undefined' && utils_1.isProduction(), businessId: (_a = businessData === null || businessData === void 0 ? void 0 : businessData.body) === null || _a === void 0 ? void 0 : _a.id, key: elem.label, className: "inputBlock", businessDataEdited: businessDataEdited })));
        });
        return inputsArray;
    };
    // Get all input block wrappers
    var getInputBlocks = function () {
        var inputBlocksArray = [];
        var inputBlocks = __spreadArrays(InputBlocks_1["default"].blocks);
        inputBlocks.forEach(function (block) {
            if (!(!state.generalSettingsData.feedback_config &&
                block.title === 'User Feedback')) {
                inputBlocksArray.push(react_1["default"].createElement("div", { className: "generalSettingsBlock", key: block.title },
                    block.title && (react_1["default"].createElement("div", { className: "generalSettingsTitle" }, block.title)),
                    react_1["default"].createElement("div", { className: "generalSettingsInputs " + block.className },
                        block.title === 'User Feedback' && (react_1["default"].createElement(DefaultInfo, null,
                            react_1["default"].createElement("div", null,
                                react_1["default"].createElement(InfoIconV4_1["default"], { size: "medium", iconColor: "yellow.dark" })),
                            react_1["default"].createElement(text_1["default"], { variant: "body.md" }, "To enable SAC agent feedback, please follow these steps and then email support@haptik.ai with the Business Name. The setup will be confirmed within 24 hours via email."))),
                        getInputs(block))));
            }
        });
        return inputBlocksArray;
    };
    // Get the whole general settings' content
    var getGeneralSettingsContent = function () {
        // Check if data exists
        if (businessData.body) {
            return getInputBlocks();
        }
        // If it doesn't wait for loading to finish
        if (!isLoaderActive) {
            return react_1["default"].createElement("div", null, "No data available");
        }
    };
    return (react_1["default"].createElement(TabContainer_1["default"], { title: "General Settings", isSaveDisabled: !businessDataEdited, isLoaderActive: isLoaderActive, onSave: updateGeneralSettings },
        react_1["default"].createElement("div", { className: "generalSettings" }, getGeneralSettingsContent())));
};
exports["default"] = GeneralSettings;
var templateObject_1;
